import { ensureAll } from '../store/driversSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';



function DriverSelectStateful({ value, setValue, ...props }) {
    const dispatch = useDispatch();
    const _drivers = useSelector((state) => state.drivers.knownDrivers);
    const drivers = Object.values(_drivers).sort((a, b) => a.driver_firstname.localeCompare(b.driver_firstname));

    useEffect(() => {
        dispatch(ensureAll());
    }, []);

    useEffect(() => {
        if(!drivers.length) return;
        if(value) return;
        setValue(drivers[0].driver_id);
    }, [drivers]);

    return (
        <select value={value} onChange={(e) => setValue(e.target.value)} {...props} >
            { drivers.map(driver => (
                <option value={driver.driver_id}>{driver.driver_firstname} ({driver.driver_username})</option>
            )) }
        </select>
    );
};

export default DriverSelectStateful;